import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { FormStateModel } from '@libs/form/models';
import { FormStateStore } from './form-state.store';

@Injectable({ providedIn: 'root' })
export class FormStateQuery extends Query<FormStateModel> {
  public constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    protected override store: FormStateStore,
  ) {
    super(store);
  }
}
